import React from 'react';

function Home() {
    return (<div>
        <div className="centered">
            <div style={{fontSize: 12, lineSpacing: 1.6, textAlign: 'center', justifyContent: 'center', maxWidth: 300, lineHeight: 1.6}} >
            To book an appointment, Please visit a scheduling page using it's URL.
            </div>
        </div>

    </div>);
}

export default Home;